import axios from "../../apiFc24";

export type SavedSquad = {
  name: string;
  id: string;
};

export const getSquads = async () => {
  const res = await axios.get<SavedSquad[]>("/saved-squads");
  return res.data;
};
